import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'antd';
import upgradeImg from './img/upgradeModal_bg.png';
import './upgradeModal.less';

// 推广费-弹窗底部的确认和取消按钮（设计统一样式）
const UpgradeModal = (props = {}) => {
    const {
        visible = false,
        onCancel
    } = props;
    return <div>
        <Modal
            open={visible}
            closable={false}
            width={540}
            footer={null}
            wrapClassName="upgradeModalCommon"
        >
            <div className="upgradeTxt" style={{
                background: `url(${upgradeImg}) no-repeat`,
                backgroundSize: '100% 100%',
            }}>
                <div className='title_div'><p>一些小优化</p><img src={require('../../assets/images/product/new 32x16@3x.png')} alt=''/></div>
                <div className='tip_div'>
                    <p>上下架</p>
                    <span><i/>机构团队产品随总部自动上架，不需要再逐级手动上架了</span>
                </div>
                <div className='tip_div'>
                    <p>推广费配置</p>
                    <span><i/>可以不使用模板直接配费，也可以用模板批量给多个同级机构/团队配费</span>
                    <span><i/>推广费模板只用来配费，跟产品上下架无关</span>
                    <span><i/>可以复制团队推广费给其他任意同级团队</span>
                </div>
            </div>
            <div className="footerBtnWrap">
                <Button className="footerBtn" type="primary" onClick={() => {
                    onCancel && onCancel();
                }}>马上体验</Button>
            </div>
        </Modal>
    </div>;
};


export default UpgradeModal;
